import { createAction } from '@mews/framework';
import { CommanderThunkAction } from '@mews-commander/types';
import { getCurrentUrl, anonymizeUrl } from '@mews-commander/utils';
import { trackEvent } from '../../../middleware/createAnalyticsMiddleware';
import { withActiveModalBody } from '../../modalManager/utils';
import { FILTER_HIDDEN, FILTER_SHOWN } from './types';

const filterClass = 'without-filter';
const FILTER_EVENT_CATEGORY = 'ReportFilterSidebar';

export const hideFilter = (): CommanderThunkAction => (dispatch) => {
    dispatch(withActiveModalBody((modal) => modal.classList.add(filterClass)));
    return dispatch(createAction(FILTER_HIDDEN, {}));
};

const showFilter = (): CommanderThunkAction => (dispatch) => {
    dispatch(withActiveModalBody((modal) => modal.classList.remove(filterClass)));
    return dispatch(createAction(FILTER_SHOWN, {}));
};

export const toggleFilter = (): CommanderThunkAction => (dispatch) => {
    dispatch(
        withActiveModalBody((modal) => {
            const isFilterClosed = modal.classList.contains(filterClass);
            const eventAction = isFilterClosed ? 'opened' : 'closed';

            const url = getCurrentUrl();
            dispatch(trackEvent({ eventCategory: FILTER_EVENT_CATEGORY, eventAction, eventLabel: anonymizeUrl(url) }));

            if (isFilterClosed) {
                return dispatch(showFilter());
            }
            return dispatch(hideFilter());
        })
    );
};
